import React from 'react';
import {Button} from 'reactstrap';
import {AvForm} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import DataTable from "../../shared/component/dataTable/DataTable";
import MixAndMatchColumn from "../../shared/component/dataTable/columns/MixAndMatchColumn.json";
import MixAndMatchService from "../../shared/service/MixAndMatchService";
import '../../shared/styles/SettingsPage.css';


export default class MixAndMatchList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredProducts: []
        }
        this.mixAndMatchService = new MixAndMatchService();
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
       this.refDataTable.refresh();
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        {this.mixAndMatches()}
                    </div>
                </AvForm>
            </div>
        );
    }


    mixAndMatches() {
        return (
            <>
                <div className="settings-page__header">
                    <h1 className="settings-page__title">Mix And Match</h1>
                </div>
                <div className="settings-page__panel settings-page__section">
                    {GeneralUtils.checkPrivilege("post_product/mixandmatch") &&
                        <div className="settings-page__toolbar settings-page__toolbar--start">
                            <Button color="outline-primary" className="settings-page__btn--add" onClick={() => {
                                window.location.href = "#mixAndMatchSave?"
                            }}>
                                <Translate contentKey="entity.action.add">Add</Translate>
                            </Button>
                        </div>}
                    {GeneralUtils.checkPrivilege("put_product/mixandmatch/all") &&
                        <div className="settings-page__table-wrap">
                            <DataTable ref={(elem) => this.refDataTable = elem}
                                       fields={MixAndMatchColumn.fields}
                                       objectName={MixAndMatchColumn.name}
                                       rows={5}
                                       dataURL={"product/mixandmatch/all"}
                                       selectionMode="single" onDataSelect={this.onDataSelect}
                                       loading={this.state.loading}/>
                        </div>}
                </div>
            </>
        );
    };


    onDataSelect = (data) => {
        window.location.href = "#mixAndMatchSave?"+data.id;
    }


}
